export const platformAdminIdentityCustomFields = {
  columns: {
    fieldKey: "項目キー",
    label: "項目名",
    dataType: "型",
    required: "必須",
    visibility: "表示設定",
    editability: "編集設定",
    sortOrder: "並び順",
  },
  values: {
    archived: "アーカイブ済み",
    visible: "表示",
    hidden: "非表示",
    editable: "編集可",
    readonly: "読み取り専用",
  },
  dataTypes: {
    text: "単一行テキスト",
    textarea: "複数行テキスト",
    number: "数値",
    select: "単一選択",
    boolean: "真偽値",
    date: "日付",
  },
  actions: {
    createDefinition: "項目定義を作成",
    userValues: "ユーザーカスタム項目",
  },
  forms: {
    createTitle: "ユーザーカスタム項目を作成",
    editTitle: "ユーザーカスタム項目を編集 · {name}",
    fieldKey: "項目キー",
    label: "項目名",
    dataType: "型",
    required: "必須",
    visibility: "表示設定",
    editability: "編集設定",
    sortOrder: "並び順",
    options: "選択肢",
    optionsText: "選択肢（1行1件）",
    requiredField: "{label} を入力してください",
    requiredFieldKey: "項目キーを入力してください",
    requiredLabel: "項目名を入力してください",
    requiredDataType: "型を選択してください",
    requiredOptions: "選択肢を1行ずつ入力してください",
  },
  drawers: {
    userValues: "ユーザーカスタム項目 · {name}",
    userValuesShort: "ユーザーカスタム項目",
  },
  alerts: {
    userValues:
      "カスタム項目値を統合認証 user_profiles.custom_fields_json に保存し、業務アプリは必要に応じて ID 主データを参照します。",
  },
  confirms: {
    archiveTitle: "項目定義をアーカイブ",
  },
  messages: {
    loadUserValuesFailed: "ユーザーカスタム項目の読み込みに失敗しました",
    noTargetUser: "対象ユーザーが選択されていません",
    valuesSaved: "ユーザーカスタム項目を保存しました",
    valuesSaveFailed: "ユーザーカスタム項目の保存に失敗しました",
    definitionCreated: "項目定義を作成しました",
    definitionCreateFailed: "項目定義の作成に失敗しました",
    definitionUpdated: "項目定義を更新しました",
    definitionUpdateFailed: "項目定義の更新に失敗しました",
    definitionArchived: "項目定義をアーカイブしました",
    archivedReadonly:
      "アーカイブ済みの項目定義は監査保持用の終端状態であり、編集や復元はできません",
    definitionArchiveFailed: "項目定義のアーカイブに失敗しました",
    noArchivableDefinitions: "現在の選択にはアーカイブ可能な項目定義がありません",
    batchDefinitionArchived: "{count} 件の項目定義をアーカイブしました",
    batchDefinitionArchivePartialFailed: "{count} 件の項目定義のアーカイブに失敗しました",
  },
} as const;
